export function IndividualLicensePage() {
  return (
    <article className="legal-document">
      <h1>Termos da Licença de Uso Individual de Ebooks</h1>
      <p className="text-muted">
        LONDON SIM GESTÃO DE DOCUMENTOS LTDA (Datasci Editora) — CNPJ 22.390.588/0001-70
      </p>

      <section>
        <h2>1. Concessão da Licença</h2>
        <p>
          A compra individual de qualquer obra digital na plataforma Datasci Editora concede ao adquirente uma{" "}
          <strong>licença de uso individual, não exclusiva, irrevogável (salvo hipótese de reembolso) e intransferível</strong>,
          estritamente destinada a uso pessoal e educacional do comprador.
        </p>
      </section>

      <section>
        <h2>2. Janela de Download e Acesso aos Arquivos (24 Meses)</h2>
        <p>
          O comprador tem direito ao download ilimitado dos arquivos digitais adquiridos (formatos PDF e EPUB) pelo período de{" "}
          <strong>24 (vinte e quatro) meses</strong> a contar da data de confirmação do pagamento via Pix.
        </p>
        <ul>
          <li>
            Durante a vigência dos 24 meses, novas versões corrigidas ou revisadas publicadas pela editora poderão ser baixadas sem
            custo adicional através da aba <strong>Minha Biblioteca</strong>.
          </li>
          <li>
            Decorrido o prazo de 24 meses, o registro da compra permanece listado no histórico da conta do usuário, mas os links de
            download direto pela plataforma são descontinuados. Recomenda-se enfaticamente que o adquirente realize cópia de
            segurança local de seus arquivos durante a janela ativa.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Filosofia Sem DRM Restritivo (DRM-Free)</h2>
        <p>
          A Datasci Editora preza pela portabilidade, longevidade e liberdade de leitura dos seus leitores. Por esse motivo, os ebooks
          são fornecidos <strong>livres de tecnologias de gerenciamento de direitos digitais obstrutivas (DRM proprietário)</strong>,
          permitindo sua leitura em qualquer aplicativo, leitor dedicado (e-reader), tablet ou computador compatível.
        </p>
      </section>

      <section>
        <h2>4. Limitações e Proibições</h2>
        <p>
          A ausência de travas tecnológicas não configura renúncia de direitos autorais. O comprador declara expressamente que NÃO irá:
        </p>
        <ul>
          <li>Sublicenciar, revender, alugar, doar ou transferir a terceiros sua licença de acesso;</li>
          <li>Compartilhar os arquivos em repositórios abertos, grupos de compartilhamento em redes sociais ou redes peer-to-peer (P2P);</li>
          <li>Utilizar o conteúdo das obras para alimentação ou treinamento de modelos de inteligência artificial de terceiros sem expressa autorização do autor;</li>
          <li>Remover identificadores editoriais, ficha catalográfica ou notas de copyright das obras.</li>
        </ul>
      </section>

      <section>
        <h2>5. Sanções Legais</h2>
        <p>
          A violação destas disposições sujeita o infrator às sanções civis de reparação de danos e às cominações penais previstas no
          artigo 184 do Código Penal Brasileiro e na Lei nº 9.610/1998 (Lei de Direitos Autorais).
        </p>
      </section>
    </article>
  );
}
